// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"95":"d4706554","453":"937f531b"}[chunkId] + ".chunk.js";
};